<div class="row mh-100">
    <div class="col-md-5 mx-auto p-2 p-md-5">
        <div class="card bg-light border-0 rounded-3">
            <div class="card-body">
                <div class="text-center">
                    <img class="mb-3 logo" src="/assets/logo.png"><br>
                    <div class="fw-bold">
                        Reset Password
                    </div>
                    <div>Please create new password</div>
                </div>
                <div class="row">
                    <form class="p-3 col-12" [formGroup]="loginForm" #thisForm="ngForm" (ngSubmit)="submitForm(loginForm)" novalidate>
                        <div class="form-floating mb-4 position-relative">
                            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" [class.is-invalid]="loginForm.get('password')?.invalid && (thisForm.submitted || loginForm.get('password')?.touched)" placeholder="Password" class="form-control" required>
                            <button class="btn position-absolute end-0 top-0 h-100 me-3 outline-none border-0 shadow-none" type="button" (click)="showPassword=!showPassword" tabindex="-1">
                                <i class="material-icons">
                                    {{showPassword ? 'visibility' : 'visibility_off'}}
                                </i>
                            </button>
                            <label>Create New Password</label>
                            <div class="text-danger position-absolute w-100" *ngIf="loginForm.get('password')?.invalid && (thisForm.submitted || loginForm.get('password')?.touched)">
                                <small *ngIf="loginForm.get('password')?.errors?.required">Create new password&nbsp;</small>
                                <small *ngIf="loginForm.get('password')?.errors?.minlength">Password is at least 6 characters&nbsp;</small>
                                <small *ngIf="loginForm.get('password')?.errors?.pattern">Must contain letters/numbers and special characters</small>
                                <small *ngIf="loginForm.get('password')?.errors?.serverError">{{loginForm.get('password')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="form-floating mb-4">
                            <input [type]="showPassword ? 'text' : 'password'" formControlName="password_confirmation" [class.is-invalid]="loginForm.get('password_confirmation')?.invalid && (thisForm.submitted || loginForm.get('password_confirmation')?.touched)" placeholder="Repeat Password" class="form-control" required>
                            <label>Repeat Password</label>
                            <div class="text-danger position-absolute w-100" *ngIf="loginForm.get('password_confirmation')?.invalid && (thisForm.submitted || loginForm.get('password_confirmation')?.touched)">
                                <small *ngIf="loginForm.get('password_confirmation')?.errors?.required">Repeat new password&nbsp;</small>
                                <small *ngIf="loginForm.get('password_confirmation')?.errors?.passwordMismatch">Password is not same&nbsp;</small>
                                <small *ngIf="loginForm.get('password_confirmation')?.errors?.serverError">{{loginForm.get('password_confirmation')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between mb-4">
                            <div class="col-12">
                                <button type="submit" [attr.disabled]="loading.status?'disabled':null" class="btn btn-primary py-2 px-4 w-100">
                                    Save Password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showNotification" class="success d-flex justify-content-center align-items-center position-fixed w-100 h-100">
    <div class="card bg-light text-dark fw-bold">
        <div class="card-body">
            <div class="text-center p-3">
                <div class="alert alert-success">
                    Congratulations your password successfully reset, now you can login to your account.
                </div>
                <p>
                    <button (click)="closeNotification()" class="btn btn-primary w-100 text-white">
                        Login
                    </button>
                </p>
            </div>
        </div>
    </div>
</div>
